import styled from 'styled-components'

const Tag = styled.div`
	background: ${props => props.theme.backgroundLight};
	border-radius: 4px;
	color: ${props => props.theme.textLight};
	font-size: 0.6rem;
	font-weight: 600;
	padding: 0.1rem 0.25rem;
	text-transform: uppercase;
	white-space: nowrap;

	${props => props.orange && `
		background: ${props.theme.orange};
		color: ${props.theme.white};
	`}

	${props => props.primary && `
		background: ${props.theme.primary};
		color: ${props.theme.white};
	`}

	${props => props.large && `
		font-size: 0.7rem;
		padding: 0.15rem 0.35rem;
	`}
`

export default Tag
